/* eslint-disable */
import React, {SyntheticEvent, useState} from 'react';
import {Checkbox, FilterOptionsState, Paper, Popper} from '@mui/material';
import {Autocomplete, AutocompleteData} from 'mui-rff';
import {createFilterOptions} from '@mui/material/useAutocomplete';
import {AutoCompleteProps} from '@/components/forms/Autocomplete/types';
import {useTranslation} from 'react-i18next';

const AutocompleteWrapper = (props: AutoCompleteProps): any => {
    const {
        value,
        options,
        required,
        limitTags,
        label,
        name,
        freeSolo,
        multiple,
        selectOnFocus,
        clearOnBlur,
        handleHomeEndKeys,
        textFieldProps,
        helperText,
        withCheckboxes,
        disableClearable,
        disableCloseOnSelect,
        onChangeParent,
        ...otherProps
    } = props;

    const setValue = () => {
        const filter = options.filter((option: any) => {
            if (!multiple)
                return option.value === value
            else
                for (let i = 0; i < value.length; i++) {
                    if (option.value == value[i].value) {
                        return false;
                    }
                }
            return true;
        });

        if (multiple) {
            return filter
        }
        return filter[0];
    }

    const [inputValue, setInputValue] = useState('')

    const {t} = useTranslation();

    const filter = createFilterOptions<AutocompleteData>();

    const renderOption = (props: any, option: any, {selected}: any) =>
        option.inputValue ? (
            option.label
        ) : (
            <li {...props}>
                {withCheckboxes && <Checkbox style={{marginRight: 8}} checked={selected}/>}
                {option.label}
            </li>
        );

    const onChange = (_event: SyntheticEvent, newValue: any, reason: string, details: any) => {
        console.log('newValue', newValue, reason, details);
        if (newValue && reason === 'selectOption' && details?.option.inputValue) {
            // Create a new value from the user input
            options.push({
                value: details?.option.inputValue,
                label: details?.option.inputValue,
            });
        }

        // hack
        if (onChangeParent) {
            onChangeParent(newValue);
        }
    };

    const filterOptions = (options: any[], params: FilterOptionsState<AutocompleteData>) => {
        // Suggest the creation of a new value
        if (params.inputValue !== '') {
            return filter(options, params);
        }

        return options;
    };

    let propsAuto: any = {
        disablePortal: true,
        ...otherProps,
        limitTags,
        label,
        name,
        multiple,
        required,
        options,
        getOptionValue: (option: any) => option.value,
        getOptionLabel: (option: any) => option.label,
        disableCloseOnSelect,
        disableClearable,
        renderOption,
        freeSolo: false,
        onChange,
        filterOptions,
        selectOnFocus,
        clearOnBlur,
        handleHomeEndKeys,
        textFieldProps,
        helperText,
        noOptionsText: t('common.no_options'),
        getOptionDisabled: (option: any) => option.disabled,
        inputValue,
        onInputChange: (_: any, newInputValue: any) => setInputValue(newInputValue),
        PaperComponent: Paper
    }

    if (value !== undefined) {
        propsAuto = {
            value: setValue(),
            ...propsAuto
        }
    }

    //console.log(propsAuto)

    return (
        <Autocomplete
            {...propsAuto}
            PopperComponent={({ style, ...props }) => {
                return (
                    <Popper
                        {...props}
                        placement='bottom'
                        style={{ ...style, maxHeight: 50 }} // width is passed in 'style' prop
                    />
                )
            }}

        />
    );
};

export default AutocompleteWrapper;
